var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V7H7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00074 15C10.1009 15.0006 11.18 14.6988 12.1202 14.1275C13.0603 13.5562 13.8253 12.7373 14.3315 11.7606C14.8377 10.7838 15.0655 9.68662 14.9902 8.58906C14.9148 7.4915 14.5392 6.43579 13.9043 5.53734C13.2694 4.63889 12.3997 3.9323 11.3902 3.49481C10.3808 3.05733 9.27056 2.90579 8.18082 3.05678C7.09109 3.20776 6.06385 3.65545 5.2114 4.3509C4.35896 5.04634 3.71413 5.96278 3.34741 7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.595c2cb00b51a614fdf2bed1aa69c7df.svg";
export { ForwardRef as ReactComponent };